// extracted by mini-css-extract-plugin
module.exports = {"theComp":"SwiperJpC_theComp__Gkw6W"};